import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, Menu, Sparkles, X } from "lucide-react";

/* Standalone shell for BrandsByIndia pages — NO EcomCatalog tabs.
   Own navbar: How It Works / Pricing / Sign In (brand + seller) / Get Listed. */
export default function BbiShell({ children }) {
  const [open, setOpen] = useState(false);
  const [signOpen, setSignOpen] = useState(false);

  const links = [
    { label: "Brands", to: "/brands/all" },
    { label: "How It Works", to: "/brands/how-it-works" },
    { label: "Pricing", to: "/brands/pricing" },
  ];

  return (
    <div className="mkt-shell">
      <header className="sticky top-0 z-40 border-b border-white/[0.07] bg-[#030712]/85 backdrop-blur-xl" data-testid="bbi-navbar">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
          <Link to="/brands" className="flex items-center gap-2.5" data-testid="bbi-logo">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-indigo-500 to-fuchsia-500 grid place-items-center">
              <Sparkles className="w-4 h-4 text-white" />
            </div>
            <span className="font-mkt-display text-lg font-semibold tracking-tight text-white">
              Brands<span className="mkt-gradient-text-vivid">ByIndia</span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {links.map((l) => (
              <Link key={l.label} to={l.to} className="px-3.5 py-2 text-sm text-slate-300 hover:text-white transition-colors" data-testid={`bbi-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
                {l.label}
              </Link>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <button onClick={() => setSignOpen((v) => !v)} className="flex items-center gap-1.5 text-sm text-slate-300 hover:text-white px-3 py-2" data-testid="bbi-signin-toggle">
                Sign In <ChevronDown className={`w-3.5 h-3.5 transition-transform ${signOpen ? "rotate-180" : ""}`} />
              </button>
              {signOpen && (
                <div className="absolute right-0 top-full mt-1 w-48 bg-[#0B0F1E] border border-white/10 rounded-xl p-1.5 shadow-2xl">
                  <Link to="/brand-login" className="block px-3.5 py-2.5 text-sm text-slate-200 hover:bg-white/[0.06] rounded-lg" data-testid="bbi-brand-signin">Brand Login</Link>
                  <Link to="/login" className="block px-3.5 py-2.5 text-sm text-slate-200 hover:bg-white/[0.06] rounded-lg" data-testid="bbi-seller-signin">Seller Login</Link>
                </div>
              )}
            </div>
            <Link to="/brands/pricing" className="mkt-btn-gradient text-sm" data-testid="bbi-get-listed-btn">
              Get Listed — ₹999/mo
            </Link>
          </div>

          <button className="md:hidden p-2 text-white" onClick={() => setOpen((v) => !v)} data-testid="bbi-mobile-toggle">
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>

        {open && (
          <div className="md:hidden border-t border-white/[0.08] bg-[#030712]/95">
            <div className="px-5 py-4 flex flex-col gap-1">
              {links.map((l) => (
                <Link key={l.label} to={l.to} onClick={() => setOpen(false)} className="px-4 py-3 text-base text-slate-200 hover:bg-white/[0.04] rounded-xl">{l.label}</Link>
              ))}
              <div className="h-px bg-white/[0.08] my-2" />
              <Link to="/brand-login" className="px-4 py-3 text-base text-slate-200 rounded-xl">Brand Login</Link>
              <Link to="/login" className="px-4 py-3 text-base text-slate-200 rounded-xl">Seller Login</Link>
              <Link to="/brands/pricing" onClick={() => setOpen(false)} className="mkt-btn-gradient w-full justify-center mt-2">Get Listed — ₹999/mo</Link>
            </div>
          </div>
        )}
      </header>

      <main id="top">{children}</main>

      <footer className="border-t border-white/[0.07] py-10 mt-4" data-testid="bbi-footer">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5">
          <div>
            <div className="font-mkt-display font-semibold text-white">Brands<span className="mkt-gradient-text-vivid">ByIndia</span></div>
            <p className="text-xs text-slate-500 mt-1.5 max-w-sm">
              Verified brand pages, AI SEO articles and measurable visibility on Google, ChatGPT &amp; Gemini for Indian brands.
            </p>
          </div>
          <div className="text-xs text-slate-500 flex flex-col sm:items-end gap-1.5">
            <a href="mailto:info@ecomcatalog.ai" className="hover:text-white">info@ecomcatalog.ai</a>
            <div className="flex gap-4">
              <Link to="/brand-login" className="hover:text-white">Brand Login</Link>
              <Link to="/brands/pricing" className="hover:text-white">Pricing</Link>
            </div>
            <div>© {new Date().getFullYear()} BrandsByIndia · a product of <a href="/" className="text-indigo-400 hover:text-indigo-300">EcomCatalog AI</a></div>
          </div>
        </div>
      </footer>
    </div>
  );
}
